import React, { useState, useEffect, useCallback, useContext } from 'react'
// import { Switch } from 'antd';
import Slider from "react-slick";
import Cropper from 'react-easy-crop'
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import { getUploadSignedUrl, getViewSignedUrl } from '../api/s3Service';
import axios from 'axios';
import { BASE_URL } from '../api/api';

import getCroppedImg from '../resources/GetCroppedImg';
import { WithContext as ReactTags } from 'react-tag-input';

// import images
import UploadFile from "../assets/icons/upload-file.svg"

// File uploader 
import { useDropzone } from 'react-dropzone';
import '../styles/componentsStyles/ContentUploaderForm.scss'

// File viewer
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// import context 
import { ContentUploaderFormDisplay } from '../context/ContentUploaderDisplay';
import { UpdatePost } from '../context/UpdatePostAfterUploading';

// CODE RELATED TO PDF VIEWER 
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.js',
    import.meta.url,
).toString();
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
// CODE RELATED TO PDF VIEWER (react-pdf) END

const ContentUploaderForm = () => {
    const [contentDetails, setContentDetails] = useState({ content: [], thumbnailImage: "", thumbnailUrl: "", title: "", description: "", visibility: "public", uniqueID: "", tags: [] });

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1);
    const [croppedImage, setCroppedImage] = useState(null);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [fileUrl, setFileUrl] = useState('');
    const [fileType, setFileType] = useState('');

    const updatePost = useContext(UpdatePost);

    // Toast's 
    const notifyOnlySingleFile = () => toast("⚠️ Upload only single PDF file not exceeding more than 100MB.", { position: "top-center", });
    const notifyNoFile = () => toast("📁 Upload File", { position: "top-right", });

    // Uploaded content file 
    function onDocumentLoadSuccess({ numPages }) {
        // setNumPages(numPages);

        if (contentDetails.content[0].name.substring(contentDetails.content[0].name.lastIndexOf('.') + 1).toLowerCase() === "pdf") {
            // remove below call for production 
            extractFirstPageAsImage();
        };
    }

    const onDrop = useCallback(acceptedFiles => {
        // Do something with the files
        console.log(acceptedFiles);

        // Function to check if more than one file has ".pdf" extension, also check for size (not more than 100MB)
        function multiplePDFs(array) {
            let pdfCount = 0;
            let totalPDFSize = 0;
            let otherExtensions = new Set();

            array.forEach(file => {
                const extension = file.path.toLowerCase().split('.').pop();
                if (extension === 'pdf') {
                    pdfCount++;
                    totalPDFSize += file.size;
                } else {
                    otherExtensions.add(extension);
                }
            });

            //  Multiple PDF files, files with other extensions, or PDF file(s) exceeding 100MB found then return false
            return pdfCount > 1 || (pdfCount > 0 && otherExtensions.size > 0) || totalPDFSize > 100000000; // 100MB
        }

        // Check if there are multiple files with .pdf extension (and allow only One PDF file)
        if (multiplePDFs(acceptedFiles)) {
            console.log("Error: Multiple files with .pdf extension.");
            notifyOnlySingleFile();
        } else {
            // setUploadedFile([{ ...acceptedFiles }, { acceptedFiles }]);
            setContentDetails({
                ...contentDetails, content: acceptedFiles.map(file => Object.assign(file, {
                    preview: URL.createObjectURL(file)
                }))
            })
        }
    }, [contentDetails]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

    // tags library code Start
    const KeyCodes = {
        comma: 188,
        enter: 13,
    };
    const delimiters = [KeyCodes.comma, KeyCodes.enter];

    const handleDelete = (i) => {
        setContentDetails({ ...contentDetails, tags: contentDetails.tags.filter((tag, index) => index !== i) });
    };

    const handleAddition = (tag) => {
        setContentDetails({ ...contentDetails, tags: [...contentDetails.tags, tag] });
    };

    const handleDrag = (tag, currPos, newPos) => {
        const newTags = contentDetails.tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        setContentDetails({ ...contentDetails, tags: newTags });
    };

    const handleTagClick = (index) => {
        console.log('The tag at index ' + index + ' was clicked');
    };
    // tags library code END

    // console.log(contentDetails);

    // Uploaded file thumbnail 
    // const fileThumbnail = contentDetails.content.map(file => {
    const fileThumbnail = file => {

        // For viewing uploaded file
        if (file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase() === "pdf") {
            return (
                <Document file={file} onLoadSuccess={onDocumentLoadSuccess}// Revoke data uri after image is loaded
                    className='content-uploader-form__thumbnail content-uploader-form__thumbnail--pdf'>
                    <Page pageNumber={1} />
                </Document>
            )
        }

        if (file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase() === 'jpg' || 'png' || 'jpeg') {

            return (
                <img key={file.name}
                    className='upload-content-card__thumbnail'
                    src={file.preview}
                    alt='file'
                // onClick={openFile}
                // Revoke data uri after image is loaded
                // onLoad={() => { URL.revokeObjectURL(file.preview) }}
                />
            )
        }
    }
        ;

    useEffect(() => {
        // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
        return () => contentDetails.content.forEach(file => URL.revokeObjectURL(file.preview));
    }, [contentDetails.content]);

    // Setting First Image of multiple images as thumbnail 
    useEffect(() => {
        if (contentDetails.content.length != 0) {
            if (contentDetails.content[0].name.substring(contentDetails.content[0].name.lastIndexOf('.') + 1).toLowerCase() === 'jpg' || 'png' || 'jpeg') {
                setContentDetails({ ...contentDetails, thumbnailImage: contentDetails.content[0].preview });
            }
        }
    }, [contentDetails.content]);


    const contentUploaderFormDisplay = useContext(ContentUploaderFormDisplay);
    const closeContentUploaderForm = () => {
        contentUploaderFormDisplay.showContentUploaderFormDispatch({ type: 'closeContentUploaderForm' })
    }

    async function extractFirstPageAsImage() {
        const firstPageCanvas = document.createElement('canvas');
        const firstPageContext = firstPageCanvas.getContext('2d');
        console.log(contentDetails.content[0])

        // url: Here goes pdf url or file path 
        const pdf = await pdfjs.getDocument({
            url: contentDetails.content[0].preview
        }).promise;


        const firstPage = await pdf.getPage(1);

        const viewport = firstPage.getViewport({ scale: 2 });

        firstPageCanvas.width = viewport.width;
        firstPageCanvas.height = viewport.height;

        const renderContext = {
            canvasContext: firstPageContext,
            viewport: viewport,
        };

        await firstPage.render(renderContext).promise;

        const dataUrl = firstPageCanvas.toDataURL('image/jpeg');

        setContentDetails({ ...contentDetails, thumbnailImage: dataUrl });
    };


    let carouselSettings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    };

    const onCropComplete = (croppedArea, croppedAreaPixels) => {
        console.log(croppedArea, croppedAreaPixels)
        setCroppedAreaPixels(croppedAreaPixels)
        showCroppedImage(croppedAreaPixels);
    }

    const showCroppedImage = async (cropAreaPix) => {
        // console.log(contentDetails.thumbnailImage, "thumbnailsss")
        console.log(contentDetails, "content detalllllll")
        try {
            const croppedImage = await getCroppedImg(
                contentDetails.thumbnailImage,
                cropAreaPix,
                // rotation
            )
            console.log('donee', croppedImage)
            setCroppedImage(croppedImage);

            const imageUrl = URL.createObjectURL(croppedImage);

            const imgElement = document.getElementById('croppedThumbnailForPost');
            imgElement.src = imageUrl;
        } catch (e) {
            console.error(e)
        }
    }

    const handleCropChange = (crop) => {
        setCrop(crop);
    };

    const handleClickOnPrivate = () => {
        // Here check if it is premium member or not
    }

    const submitFormDetails = async (ID) => {
        alert(`content unique ID ${ID}, Form Submiited`);
        // Hanlde form submit API here
        console.log(contentDetails, "content details to submit");

        const key = ID + contentDetails.content[0].name.replace(/\s+/g, '');
        const contentType = contentDetails.content[0].type;
        console.log(key, contentType)

        // Get S3 URL 
        const uploadUrl = await getUploadSignedUrl(key, contentType);
        console.log(uploadUrl, "uploadUrl")
        await axios.put(uploadUrl, contentDetails.content[0], {
            headers: {
                'Content-Type': contentType,
            },
        }).then(res => {
            console.log(res, "content upload response");
            if (res.statusText === "OK") {
                viewFile(key, ID);
                alert('File uploaded successfully');
            }
        }).catch(err => console.log(err))
    }

    async function viewFile(fileKey, ID) {
        // View File after Upload
        let url = await getViewSignedUrl(fileKey);
        setFileUrl(url);
        // if (url) {
        //     closeContentUploaderForm();
        // }

        // Determine file type from the file key or URL
        if (fileKey.endsWith('.pdf')) {
            setFileType('pdf');
        } else if (fileKey.toLowerCase().match(/\.(jpeg|jpg|gif|png)$/)) {
            setFileType('image');
        } else {
            setFileType('other');
        }
        // Send this URL to MongoDB 
        console.log(url, "View URL")

        formSubmit(url, ID);
    }

    async function formSubmit(fileSignedURL, contentID) {
        // Generate unique thmubnail id 
        const uniqueThumbnailID = uuidv4();

        console.log(croppedImage, "croppedmage")

        const ThumbnailKey = uniqueThumbnailID + croppedImage.name.replace(/\s+/g, '');
        const contentType = croppedImage.type;

        // // Get S3 URL 
        const uploadThumbnailUrl = await getUploadSignedUrl(ThumbnailKey, contentType);

        await axios.put(uploadThumbnailUrl, croppedImage, {
            headers: {
                'Content-Type': contentType,
            },
        }).then(async (res) => {
            if (res.statusText === "OK") {
                const url = await getViewSignedUrl(ThumbnailKey);
                console.log(url, "thumbnailurl");
                setContentDetails({ ...contentDetails, thumbnailUrl: url });

                submitPost(url);
            }
        }).catch(err => console.log(err))


        async function submitPost(thumbnailUrl) {
            const tabDetail = JSON.parse(window.sessionStorage.getItem("activeTabDetail"));

            // Ask backend dev to add one more parameter, type: "pdf/image"
            const data = {
                id: contentID,
                storageKey: fileSignedURL,
                channelId: tabDetail.channelId,
                tabId: tabDetail.id,
                thumbnailImage: thumbnailUrl,
                title: contentDetails.title,
            }

            if (fileSignedURL !== "") {
                await axios.post(`${BASE_URL}/api/posts`, data)
                    .then(res => {
                        if (res.data.statusText === "success") {
                            // update the tab content via changing an context 
                            updatePost.updatePostDispatch({ type: "updateThePostAfterUploading" })
                            closeContentUploaderForm();
                        }
                        console.log(res, "response of form submit");
                    })
                    .catch(err => console.log(err))
            } else {
                console.log("Please wait file is uploading");
            }
        }

    }

    const submitForm = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Extract first image of PDF file uploaded by user and sent it as thumbnail 
        // extractFirstPageAsImage();  

        // Generate UniqueID for each content posted 
        const uniqueContentID = uuidv4();

        if (contentDetails.content.length === 0) {
            notifyNoFile();
        } else {
            submitFormDetails(uniqueContentID);
        }
    }

    return (
        <div className='content-uploader-form'>
            <div className="content-uploader-form__container">
                <form action="" onSubmit={submitForm} className='content-uploader-form__form'>

                    <button className="content-uploader-form__close-btn" onClick={closeContentUploaderForm}>
                        <span className="material-symbols-outlined">
                            close
                        </span>
                    </button>

                    <div className="content-uploader-form__file-container">
                        <h3 className='content-uploader-form__header-title'>Upload Post</h3>

                        {/* File uploader  */}
                        <div className='content-uploader-form__file-inner-container'>
                            {
                                contentDetails.content.length === 0 && <div className='content-uploader-form__content-uploader'>
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        {
                                            isDragActive ?
                                                <div>Drop the files here ...</div> :
                                                <div>
                                                    <img className=' content-uploader-form__upload-icon ' src={UploadFile} alt="upload" />
                                                    <br />
                                                    Drag 'n' drop some files here, or <b>Click Here</b> to select files
                                                </div>
                                        }
                                    </div>
                                </div>
                            }
                            {
                                contentDetails.content.length !== 0 && <>
                                    {
                                        contentDetails.content[0].name.substring(contentDetails.content[0].name.lastIndexOf('.') + 1).toLowerCase() !== "pdf" ? <Slider {...carouselSettings} className="content-uploader-form__uploaded-content-file">
                                            {
                                                contentDetails.content.map(file => <div key={file.path} className='content-uploader-form__thumbnail-container'>
                                                    {
                                                        fileThumbnail(file)
                                                    }
                                                </div>
                                                )
                                            }
                                        </Slider> : <div className="content-uploader-form__uploaded-content-file">
                                            {
                                                contentDetails.content.map(file => <div key={file.path} className='content-uploader-form__thumbnail-container'>
                                                    {
                                                        fileThumbnail(file)
                                                    }
                                                </div>
                                                )
                                            }
                                        </div>
                                    }

                                    <br />
                                    <br />
                                    {
                                        contentDetails.content.length !== 0 && <div {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            {
                                                contentDetails.content.length !== 0 && <div className='content-uploader-form__change-file-btn'>Change File</div>

                                            }
                                        </div>
                                    }
                                </>
                            }

                        </div>
                        {contentDetails.thumbnailImage && <div className='content-uploader-form__thumbnail-editor'>
                            {/* Thumbnail by extracting first page  from file */}
                            {/* <img className='content-uploader-form__thumbnail-hidden' src={contentDetails.thumbnailImage} alt="thumbnail" /> */}
                            <div className="content-uploader-form__thumbnail-editor-container">
                                <h3 className='content-uploader-form__header-title'>Crop Thumbnail</h3>
                                <div className="content-uploader-form__thumbnail-cropper-container">
                                    <Cropper
                                        image={contentDetails.thumbnailImage}
                                        crop={crop}
                                        zoom={zoom}
                                        showGrid={true}
                                        aspect={15 / 20}
                                        onCropComplete={onCropComplete}
                                        onCropChange={handleCropChange}
                                        onZoomChange={setZoom}
                                    />
                                </div>
                            </div>

                            <h3 className='content-uploader-form__header-title content-uploader-form__header-title--final-thumbnail'>Final Thumbnail</h3>
                            <img id="croppedThumbnailForPost" alt="cropped thumbnail" className='content-uploader-form__cropped-image' />
                        </div>}

                    </div>

                    <div className="content-uploader-form__input-fields-container">

                        <div className="content-uploader-form__input-group">
                            <label htmlFor="content-title" className='content-uploader-form__label'>Title</label>
                            <input type="text" id='content-title' className='content-uploader-form__input-field' placeholder='Enter Title' value={contentDetails.title} maxLength={100} onChange={(e) => setContentDetails({ ...contentDetails, title: e.target.value })} required />
                        </div>

                        <div className="content-uploader-form__input-group">
                            <label className='content-uploader-form__label' htmlFor="content-description">Description</label>
                            <textarea type="text" id='content-description' className='content-uploader-form__input-field' rows={10} cols={30} maxLength={1000} value={contentDetails.description} placeholder='Write something about your post...' onChange={(e) => setContentDetails({ ...contentDetails, description: e.target.value })} required />
                        </div>

                        <div className="content-uploader-form__input-group">
                            <h4 className='content-uploader-form__label'>Visibility</h4>
                            <label >
                                <input type="radio" name='visibility' value="public" className='content-uploader-form__input-field' onChange={(e) => setContentDetails({ ...contentDetails, visibility: e.target.value })} defaultChecked /> Public
                            </label>
                            <label >
                                <input type="radio" name='visibility' value="private" className='content-uploader-form__input-field' onClick={handleClickOnPrivate} onChange={(e) => setContentDetails({ ...contentDetails, visibility: e.target.value })} disabled /> Private <spanc className="content-uploader-form__premium-tag">*Premium</spanc>
                            </label>
                        </div>

                        {/* <div className="content-uploader-form__input-group"> */}
                        <label className='content-uploader-form__label' htmlFor="content-tags">Tags</label>
                        <div id="content-tags" className="content-uploader-form__tags">
                            <ReactTags
                                tags={contentDetails.tags}
                                // suggestions={suggestions}
                                delimiters={delimiters}
                                handleDelete={handleDelete}
                                handleAddition={handleAddition}
                                handleDrag={handleDrag}
                                handleTagClick={handleTagClick}
                                inputFieldPosition="bottom"
                                maxTags={10}
                                maxLength={50}
                                autofocus={false}
                                allowUnique={true}
                                autocomplete
                            />
                        </div>
                        <button type='submit' className='content-uploader-form__submit-btn'>Upload</button>
                    </div>
                    {/* </div> */}

                </form>
            </div >

            {/* {fileUrl && fileType === 'image' && (
                <div>
                    <h3>Image:</h3>
                    <img src={fileUrl} alt="File" style={{ width: '100%', maxWidth: '500px' }} />
                </div>
            )}

            {fileUrl && fileType === 'pdf' && (
                <div>
                    <h3>PDF:</h3>
                    <iframe
                        src={fileUrl}
                        title="PDF File"
                        style={{ width: '100%', height: '500px' }}
                    />
                </div>
            )}

            {fileUrl && fileType === 'other' && (
                <div>
                    <h3>File:</h3>
                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                        Download File
                    </a>
                </div>
            )} */}
        </div >
    )
}

export default ContentUploaderForm